import momenJalaali from "moment-jalali";
import DatePicker from "react-datepicker2";
import { faBroom, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { getCustomerRequestWithoutLoginList, convertCustomerRequestToService, deleteCustomerRequestwithoutLogin } from "../store/api/Services";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { ArrowUpLeftSquareFill, EyeFill, EyeSlashFill, Search } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setDialog, setErrorDialog } from "../../store/api/CommonFunctions";

const CustomerRequestWithoutLoginList = () => {
    const frmFilters = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const { handleSubmit, register } = useForm();
    const [showFilter, setShowFilter] = useState(true);
    const filterData = useSelector(state => state.service.custReqWithoutLoginFilters)
    const [dateFilters, setDateFilters] = useState({
        RequestDate: filterData?.RequestDate,
        RequestDateTo: filterData?.RequestDateTo
    })
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function searchRequest(data) {
        const pDateFrom = document.getElementsByName("RequestDate")[0].value;
        const pDateTo = document.getElementsByName("RequestDateTo")[0].value;
        if (pDateFrom !== "") {
            data.RequestDate = dateFilters.RequestDate;
        }
        if (pDateTo !== "") {
            data.RequestDateTo = dateFilters.RequestDateTo;
        }
        data.Take = 10;
        data.Skip = 0;
        dispatch(getCustomerRequestWithoutLoginList(data, () => { }));
    }
    function clearFilters() {
        frmFilters.current.reset();
        setDateFilters({
            RequestDate: null,
            RequestDateTo: null
        });
        dispatch(getCustomerRequestWithoutLoginList({ Skip: 0, Take: 10 }, () => { }));
    }
    const tableCols = [
        { colTitle: "نوع درخواست", colName: "PRequestType", justInMobile: true },
        { colTitle: "تاریخ درخواست", colName: "PRequestDate", justInMobile: true },
        { colTitle: "درخواست کننده", colName: "CustomerName", justInMobile: true },
        { colTitle: "شناسه درخواست", colName: "ID" },
        { colTitle: "موبایل درخواست کننده", colName: "CustomerMobile" },
        { colTitle: "نشانی درخواست کننده", colName: "CustomerAddress", colType: "string", maxTextLength: 120 },
        { colTitle: "سریال کالا", colName: "ProductSerial",style:{fontFamily:"Dark-Sans", fontSize:"11.5px"} }
    ]
    const tableButtons = [
        {
            title: "تبدیل درخواست", type: "common", tooltip: "تبدیل درخواست", className: "btn-info group-Btn-smalll",
            icon: <ArrowUpLeftSquareFill color="#6b00ff" size={17} />, showCondition: (row) => !row.RelatedEntityID,
            onclick: (item) => convertCustomerRequest(item.ID)
        },
        {
            title: "حذف درخواست", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف درخواست',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteRequest(item.ID)
                }))
            }
        }
    ]
    function deleteRequest(requestID) {
        return () => {
            deleteCustomerRequestwithoutLogin(requestID, onDelete);
        }
    }
    function onDelete(res) {
        if (res === "PENDING") {
            return;
        }
        if (res.Error) {
            setErrorDialog(dispatch, res.Error, "حذف درخواست");
        }
        searchRequest(filterData);
    }

    function convertCustomerRequest(requestID) {
        const onSuccess = (res) => {
            if (res === "PENDING") {
                return;
            }
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "تبدیل درخواست");
            }
            else if (res.ServiceID) {
                //searchRequest(filterData);
                history.push(`/Services/Service/${res.ServiceID}/${res.ServiceType}`, null);
            }
        }
        convertCustomerRequestToService(requestID, onSuccess);
    }
    useEffect(() => {
        document.body.className = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faFileAlt} size="lg" />&nbsp;
                    درخواست های سریع مشتریان
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <form readOnly onSubmit={handleSubmit(searchRequest)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <div className="col-md-2 form-group">
                                <label>نوع درخواست:</label>
                                <select className="form-control" defaultValue={filterData?.RequestType ?? ""} name="RequestType" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="repair">درخواست تعمیر</option>
                                    <option value="install">درخواست نصب</option>
                                </select>
                            </div>
                            <Col md={2} className="form-group">
                                <label>شناسه درخواست: </label>
                                <Form.Control defaultValue={filterData?.ID ?? ""} name="ID" ref={register({})} />
                            </Col>
                            <div className="col-md-2 form-group">
                                <label>تاریخ درخواست از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="RequestDate"
                                    value={dateFilters.RequestDate ? momenJalaali(dateFilters.RequestDate) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, RequestDate: value.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>تاریخ درخواست تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="RequestDateTo"
                                    value={dateFilters.RequestDateTo ? momenJalaali(dateFilters.RequestDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, RequestDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>درخواست کننده:</label>
                                <input type="text" className="form-control"
                                    defaultValue={filterData?.CustomerName ?? ""} ref={register({})} name="CustomerName" />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>وضعیت درخواست: </label>
                                <select className="form-control" defaultValue={filterData?.NewOnes ?? ""} name="NewOnes" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={true}>تبدیل نشده</option>
                                    <option value={false}>تبدیل شده</option>
                                </select>
                            </div>
                        </Row>
                        <Button type="submit" variant="secondary" className="group-Btn-large mt-2"><Search size={15} />&nbsp;جستجوی درخواست</Button>
                    </form>
                    <BihamtaTable rowButtons={tableButtons} columns={tableCols} reducerName="service" objectName="custReqWithoutLoginList" filterData={filterData} hasPaging={true}
                        searchMethod={(data) => dispatch(getCustomerRequestWithoutLoginList(data, () => { }))} />
                </Card.Body>
            </Card>
        </div>
    )
}
export default CustomerRequestWithoutLoginList;